module.exports = __webpack_public_path__ + "img/chevrone-check.e6a38695.svg";